<template>
  <nav class="math-nav clearfix">
    <div class="float-right">
      <a href="https://mathwallet.org" class="mobile" target="_blank">
        <img src="@/static/img/icons/phone_blue@2x.png" height="16" />
        <span>{{ $t("webwallet_mobile_app") }}</span>
      </a>
      <!--切换链-->
      <div class="dropdown">
        <a
          href="javascript:;"
          class="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
        >
          {{ selectedChain }}<span class="tri"></span>
        </a>
        <ul class="dropdown-menu chain-name-list dropdown-overflow">
          <li
            v-for="(node, index) in chainNameList"
            :key="index"
            @click="changeNode(node, index)"
          >
            {{ node }}
          </li>
        </ul>
      </div>
      <div class="dropdown">
        <a
          href="javascript:;"
          class="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
        >
          {{ $t("lang") }}<span class="tri"></span>
        </a>
        <ul class="dropdown-menu">
          <li @click="changeLang('en')">English</li>
          <li @click="changeLang('cn')">中文</li>
          <li @click="changeLang('ko')">한국어</li>
        </ul>
      </div>
      <div class="dropdown">
        <a
          href="#"
          class="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="cUnit">{{ unit }}</span> <span class="caret"></span>
        </a>
        <ul class="dropdown-menu dropdown-overflow">
          <li v-for="coin in coins" @click="toggleUnit(coin)">{{ coin }}</li>
        </ul>
      </div>
    </div>
    <a class="logo" href="https://mathwallet.org" target="_blank">
      <img
        src="@/static/img/icons/MathWallet_Logo_Horizontal_White.png"
        height="44"
      />
    </a>
  </nav>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters({
      chainNameList: "chainNameList",
      coins: "coins",
    }),
  },
  methods: {
    ...mapActions(["setCurrentChain", "setUnit", "setAccount"]),
    changeLang(lang) {
      this.$i18n.setUserLanguage(lang);
    },
    toggleUnit(unit) {
      this.setUnit(unit);
    },
    // 切换链
    changeNode(value, index) {
      let chain = index.toLowerCase();
      if (chain == this.currentChain) {
        return false;
      }
      this.setAccount();
      this.setCurrentChain(chain);
      this.$router.push("../" + chain);
    },
  },
  watch: {
    unit: "coinChange",
  },
};
</script>
<style scoped>
.logo {
  margin: -6px 0;
  float: left;
}
.chain-name-list {
  width: 300px !important;
}
.dropdown-overflow {
  overflow-y: scroll;
  max-height: calc(100vh - 100px);
}
</style>
